import styled from 'styled-components';
import { IonModal } from '@ionic/react';

export const IonModalWrapper = styled(IonModal)``;
